import { Testimonials } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import LazyLoadMedia from 'app/helpers/LazyLoadMedia'

type TEditableTestimonial = {
  imageUrl: string
  imageAlt: string
} & Omit<TAttributes['testimonials'][number], 'image'>

type TAttributes = React.ComponentProps<typeof Testimonials>

export interface IAttributes extends Omit<TAttributes, 'testimonials'> {
  testimonials: TEditableTestimonial[]
}

const TestimonialsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <Testimonials
      {...attributes}
      testimonials={attributes.testimonials.map((testimonial) => ({
        ...testimonial,
        image: <LazyLoadMedia mediaUrl={testimonial.imageUrl} altText={testimonial.imageAlt} objectFit="cover" />,
      }))}
    />
  )
}

export default TestimonialsBlock
